import { Theme, css } from '@emotion/react';

function getColorFromState(
  { fgDangerBase, fgDisabled }: Theme['colors'],
  disabled: boolean,
  error: boolean,
  fallback: string
) {
  if (disabled) {
    return fgDisabled;
  }
  if (error) {
    return fgDangerBase;
  }
  return fallback;
}

export const counterFieldRoot =
  () =>
  ({ spacing }: Theme) => css`
    &.MuiFormControlLabel-root {
      display: grid;
      margin: 0;
    }

    & > .MuiFormControlLabel-label {
      order: -1;
    }

    & > .MuiFormControlLabel-label > div {
      padding: 0;
    }
  `;

export const counterFieldHelperText =
  (disabled: boolean, error: boolean) =>
  ({ spacing, colors }: Theme) => css`
    color: ${getColorFromState(colors, disabled, error, colors.fgSubtle)};
    margin-top: ${spacing(0.5)}px;
  `;

export const counterFormControlRoot = (fullWidth: boolean) => css`
  display: flex;
  // FIX: We should address this in the future not part of the fixit
  width: ${fullWidth ? '100%' : '16rem'};
`;

export const addAround = ({ spacing }: Theme) => css`
  order: 3;
  margin-left: ${spacing(1)}px;
`;

export const subtractAround = ({ spacing }: Theme) => css`
  order: 3;
  margin-left: ${spacing(1)}px;
`;

export const inputAround = css`
  order: 2;
`;

export const addStart = ({ spacing }: Theme) => css`
  order: 2;
  margin-right: ${spacing(1)}px;
`;

export const subtractStart = ({ spacing }: Theme) => css`
  order: 1;
  margin-right: ${spacing(1)}px;
`;

export const inputStart = css`
  order: 3;
`;

export const addEnd = () => css`
  order: 3;
`;

export const subtractEnd = ({ spacing }: Theme) => css`
  order: 2;
  margin-right: ${spacing(1)}px;
`;

export const inputEnd = ({ spacing }: Theme) => css`
  order: 1;
  margin-right: ${spacing(1)}px;
`;

export const input = css`
  & .MuiInputBase-input {
    text-align: center;
  }
`;

export const inputValueStart = css`
  & .MuiInputBase-input {
    text-align: left;
  }
`;

export const inputValueEnd = css`
  & .MuiInputBase-input {
    text-align: right;
  }
`;
